import { render, staticRenderFns } from "./RestaurantContent.vue?vue&type=template&id=580fdf38&"
import script from "./RestaurantContent.vue?vue&type=script&lang=js&"
export * from "./RestaurantContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports